import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function accessoryRelatedList(
  accessory_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/accessory/${accessory_id}/related/list${queryString}`,
  );
}

export async function accessoryRelatedAccessoryList(
  accessory_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/accessory/related/${accessory_id}/accessory/list${queryString}`,
  );
}

export async function accessoryRelatedListId(accessory_id: string) {
  return await clientAxios.get(
    `admin/accessory/${accessory_id}/related/list/id`,
  );
}

export async function accessoryRelatedListOwnerIdByAccessory(
  accessory_id: string,
) {
  return await clientAxios.get(`admin/accessory/related/${accessory_id}/list/id`);
}

export async function accessoryRelatedGet(item_id: string) {
  return await clientAxios.get(`admin/accessory/related/${item_id}/show`);
}

export async function accessoryRelatedCreate(
  accessory_id: string,
  payload: Partial<any>,
) {
  return await clientAxios.post(
    `admin/accessory/${accessory_id}/related/create`,
    payload,
  );
}

export async function accessoryRelatedDelete(item_id: string) {
  return await clientAxios.del(`admin/accessory/related/${item_id}/delete`);
}
